import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-promotions-list',
	templateUrl: './promotions-list.component.html',
	styleUrls: ['./promotions-list.component.css'],
})
export class PromotionsListComponent extends ListComponent {
	protected apiType = 'bag';
	protected apiUrl = 'offer/promotion';
	promotions = [];
	tableRows = [
		{ id: 'id', name: 'ID' },
		{ id: 'name', name: 'Nazwa' },
		{ id: 'description', name: 'Opis' },
		{ id: 'promotionSells', name: 'Zakres sprzedaży' },
		{ id: 'promotionOffers', name: 'Zakres czasowy ofert' },
		{ id: 'isActiveView', name: 'Aktywne' },
	];
	filters;
	parameters = {
		yesno: [
			{ id: 1, name: 'Tak', value: 'true' },
			{ id: 2, name: 'Nie', value: 'false' },
		],
		products: [],
	};

	protected loadBefore(): void {
		this.bag.get('/product/', (result, error) => {
			this.parameters.products = result.results;
			this.loadData();
		});
	}

	protected convertData(result) {
		return result.results.map((obj) => {
			obj.isActiveView = obj.isActive ? 'Tak' : 'Nie';
			// obj.products = obj.products.map((item) => {
			// 	return item['name'];
			// });
			obj.promotionSells = this.formatDataObjectToString(obj.promotionSells, 'sell');
			obj.promotionOffers = this.formatDataObjectToString(obj.promotionOffers, 'offer');
			return obj;
		});
	}

	private formatDataObjectToString(array, property) {
		let result = '';
		array.forEach((item) => {
			result += item[property].lower + ' - ' + item[property].upper + '; ';
		});
		result = result.slice(0, -2);
		return result;
	}

	filtersSelected(data) {
		this.filters = { ...data, limit: '9999' };
		this.loadData();
	}
}
